// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'dark',
    variablesCss: true,
    themes: {
      light: {
        colors: {
          primary: '#ffffff',
          secondary: '#F9F7F8',
          tertiary: '#ffffff',
          accent: '#7553FC',
          text: '#212121ff',
          error: '#ca5757ff',
        },
        variables: {
          'font-family': '"Open Runde", "Montserrat", "Segoe UI", sans-serif',
        }
      },
      dark: {
        colors: {
          primary: '#ffffff',
          secondary: '#F9F7F8',
          tertiary: '#ffffff',
          accent: '#7553FC',
          text: '#1A1615',
          error: '#ca5757ff',
        },
        variables: {
          'font-family': '"Open Runde", "Montserrat", "Segoe UI", sans-serif',
        }
      },
    },
  },
})
